import React, { useContext, useEffect, useMemo, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { TableContext } from 'Context/Table'
import { UIContext } from 'Context/UI'

// import QuantityCell from 'Presentation/Components/RequestCard/Components/QuantityCell'
import QuantityInputCell from './Components/QuantityInputCell'
import TotalPriceCell from 'Presentation/Components/RequestCard/Components/TotalPriceCell'
import MultiplePriceCell from 'Presentation/Components/RequestCard/Components/MultiplePrice'
import TitleCell from './Components/TitleCell'
import QuotePriceCell from './Components/QuotePriceCell'

import { useQuotationStore } from 'Store/Quotation'
import { shallow } from 'zustand/shallow'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'
import { OEMFilter } from 'Configuration/OEMFilter'
import * as Yup from 'yup'

const ViewModel = () => {
	const itemsValidationSchema = Yup.array().of(
		Yup.object().shape({
			quantity: Yup.number()
				.min(1, 'จำนวนต้องกรอกอย่างน้อย 1 ชิ้น / รายการ')
				.required('กรุณากรอกจำนวน'),
			quotePrice: Yup.number().required('กรุณากรอกราคา'),
		})
	)

	const navigate = useNavigate()
	const { id } = useParams()
	const { setShowContentToolbar, setCustomContentToolbar } = useContext(UIContext)
	const { updateLoading, updateError, updateSorting } = useContext(TableContext)
	const { data, getOne, clearState } = useQuotationStore(
		state => ({
			data: state.selected,
			getOne: state.getOne,
			clearState: state.clearState,
		}),
		shallow
	)
	const { update, send } = useQuotationStore(
		state => ({
			update: state.update,
			send: state.send,
		}),
		shallow
	)

	const [isSubmitting, setIsSubmitting] = useState(false)
	const [isLoading, setIsLoading] = useState(false)
	const [items, setItems] = useState<any[]>([])
	const [financial, setFinancial] = useState<{
		discount: string
		isVatCalculated: boolean
	}>({
		discount: '',
		isVatCalculated: true,
	})
	const displayItems = useMemo(() => items.filter(item => !item.isDelete), [items])
	const [hasChanged, setHasChanged] = useState(false)

	const disabledInput = data?.documentStatus !== '10'
	const canSend = data?.documentStatus === '10'

	const isNegotitated = data?.documentStatus === '10' && data?.isNegotiate
	const negotitateRemark = data?.negotiateRemark

	const netBeforeVat = useMemo(() => {
		if (Object.keys(data).length === 0) return '0.00'

		if (data?.documentStatus === '10') {
			const totalItemsPrice = displayItems.reduce((acc, item) => {
				if (item.isDelete) return acc
				// if (item.isFixed) {
				if (item.quotePrice === null || item.quotePrice === '') {
					return acc
				} else {
					return acc + parseFloat(item.quotePrice) * parseFloat(item.quantity)
				}
				// } else {
				// 	if (item.quotePrice === null || item.quotePrice === '') {
				// 		return acc
				// 	} else {
				// 		return acc + parseFloat(item.quotePrice)
				// 	}
				// }
			}, 0)

			let sumPrice = totalItemsPrice

			if (
				financial.discount &&
				financial.discount !== '' &&
				!isNaN(parseFloat(financial.discount))
			) {
				sumPrice = sumPrice - parseFloat(financial.discount)
			}

			return sumPrice.toFixed(2)
		} else {
			const totalItemsPrice = displayItems.reduce((acc, item) => {
				const quotePrice = typeof item.quotePrice === 'number' ? [] : item.quotePrice ?? []
				const quantities = item.quantities ?? []

				acc += quotePrice.reduce((qPriceAcc: number, qPrice: any, idx: number) => {
					qPriceAcc += qPrice.price * quantities[idx].quantity

					return qPriceAcc
				}, 0)

				return acc
			}, 0)

			let sumPrice = totalItemsPrice

			if (
				financial.discount &&
				financial.discount !== '' &&
				!isNaN(parseFloat(financial.discount))
			) {
				sumPrice = sumPrice - parseFloat(financial.discount)
			}

			return sumPrice.toFixed(2)
		}
	}, [displayItems, financial, data])

	const net = useMemo(() => {
		if (Object.keys(data).length === 0) return '0.00'

		if (data?.documentStatus === '10') {
			const totalItemsPrice = displayItems.reduce((acc, item) => {
				if (item.isDelete) return acc
				// if (item.isFixed) {
				if (item.quotePrice === null || item.quotePrice === '') {
					return acc
				} else {
					return acc + parseFloat(item.quotePrice) * parseFloat(item.quantity)
				}
				// } else {
				// 	if (item.quotePrice === null || item.quotePrice === '') {
				// 		return acc
				// 	} else {
				// 		return acc + parseFloat(item.quotePrice)
				// 	}
				// }
			}, 0)

			let sumPrice = totalItemsPrice

			if (
				financial.discount &&
				financial.discount !== '' &&
				!isNaN(parseFloat(financial.discount))
			) {
				sumPrice = sumPrice - parseFloat(financial.discount)
			}

			if (financial.isVatCalculated) {
				return (sumPrice * 1.07).toFixed(2)
			} else {
				return sumPrice.toFixed(2)
			}
		} else {
			const totalItemsPrice = displayItems.reduce((acc, item) => {
				const quotePrice = typeof item.quotePrice === 'number' ? [] : item.quotePrice ?? []
				const quantities = item.quantities ?? []

				acc += quotePrice.reduce((qPriceAcc: number, qPrice: any, idx: number) => {
					qPriceAcc += qPrice.price * quantities[idx].quantity

					return qPriceAcc
				}, 0)

				return acc
			}, 0)

			let sumPrice = totalItemsPrice

			if (
				financial.discount &&
				financial.discount !== '' &&
				!isNaN(parseFloat(financial.discount))
			) {
				sumPrice = sumPrice - parseFloat(financial.discount)
			}

			if (financial.isVatCalculated) {
				return (sumPrice * 1.07).toFixed(2)
			} else {
				return sumPrice.toFixed(2)
			}
		}
	}, [displayItems, financial, data])

	const vatAmount = useMemo(() => {
		if (Object.keys(data).length === 0) return '0.00'

		if (data?.documentStatus === '10') {
			const totalItemsPrice = displayItems.reduce((acc, item) => {
				if (item.isDelete) return acc
				if (item.isFixed) {
					if (item.quotePrice === null || item.quotePrice === '') {
						return acc
					} else {
						return acc + parseFloat(item.quotePrice) * parseFloat(item.quantity)
					}
				} else {
					if (item.quotePrice === null || item.quotePrice === '') {
						return acc
					} else {
						return acc + parseFloat(item.quotePrice) * parseFloat(item.quantity)
					}
				}
			}, 0)

			let sumPrice = totalItemsPrice

			if (
				financial.discount &&
				financial.discount !== '' &&
				!isNaN(parseFloat(financial.discount))
			) {
				sumPrice = sumPrice - parseFloat(financial.discount)
			}

			if (financial.isVatCalculated) {
				return (sumPrice * 0.07).toFixed(2)
			} else {
				return '0.00'
			}
		} else {
			const totalItemsPrice = displayItems.reduce((acc, item) => {
				const quotePrice = typeof item.quotePrice === 'number' ? [] : item.quotePrice ?? []
				const quantities = item.quantities ?? []

				acc += quotePrice.reduce((qPriceAcc: number, qPrice: any, idx: number) => {
					qPriceAcc += qPrice.price * quantities[idx].quantity

					return qPriceAcc
				}, 0)

				return acc
			}, 0)

			let sumPrice = totalItemsPrice

			if (
				financial.discount &&
				financial.discount !== '' &&
				!isNaN(parseFloat(financial.discount))
			) {
				sumPrice = sumPrice - parseFloat(financial.discount)
			}

			if (financial.isVatCalculated) {
				return (sumPrice * 0.07).toFixed(2)
			} else {
				return '0.00'
			}
		}
	}, [displayItems, financial, data])

	const fetchData = () => {
		if (id) {
			setIsLoading(true)
			updateLoading(true)

			getOne(id).then(({ success, data }) => {
				if (!success) {
					Swal.fire({
						title: 'เกิดข้อผิดพลาด',
						text: data,
						icon: 'error',
						confirmButtonText: 'ปิด',
						customClass: {
							confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
						},
					})
					setIsLoading(false)
					updateLoading(false)
					updateError(true)
				} else {
					// Set Items
					const items = data.items.reduce((acc: any[], item: any) => {
						// Editable
						if (data.documentStatus === '10') {
							const findedOemRequestItem = data.inquiry.oemRequest.items.find(
								(oItem: any) => parseInt(oItem.id) === item.oemRequestItemId
							)

							const added = acc.find(
								(aItem: any) =>
									aItem.product?.id === item.productId &&
									aItem.oemRequestItemId === item.oemRequestItemId
							)

							acc.push({
								id: item.id,
								documentStatus: data.documentStatus,
								product: findedOemRequestItem?.product ?? {},
								oemRequestItemId: item.oemRequestItemId,
								dimension: findedOemRequestItem?.dimension ?? {},
								options: findedOemRequestItem?.options ?? [],
								accessories: findedOemRequestItem?.accessories ?? [],
								thickness: findedOemRequestItem?.thickness ?? {},
								outerMaterial: findedOemRequestItem?.outerMaterial ?? {},
								innerMaterial: findedOemRequestItem?.innerMaterial ?? {},
								printingOption: findedOemRequestItem?.printingOption ?? {},
								forming: findedOemRequestItem?.forming ?? {},
								sustainabilities: findedOemRequestItem?.sustainabilities ?? [],
								certificates: findedOemRequestItem?.certificates ?? [],
								quantity: item.quantity,
								requestPrice: item.requestPrice,
								title: item.title,
								quotePrice:
									data.documentStatus === '10'
										? item.quotePrice
											? parseFloat(item.quotePrice)
											: ''
										: item.quotePrice,
								isFixed: item.isFixed,
								remark: added ? undefined : item.remark,
								// remark: item.remark,
								isDelete: false,
								isCreate: false,
							})
						}
						// Not Editable
						else {
							const findedOemRequestItem = data.inquiry.oemRequest.items.find(
								(oItem: any) => parseInt(oItem.id) === item.oemRequestItemId
							)

							if (item.isFixed === false) {
								acc.push({
									id: item.id,
									oemRequestItemId: item.oemRequestItemId,
									documentStatus: data.documentStatus,
									product: findedOemRequestItem?.product ?? {},
									dimension: findedOemRequestItem?.dimension ?? {},
									options: findedOemRequestItem?.options ?? [],
									accessories: findedOemRequestItem?.accessories ?? [],
									thickness: findedOemRequestItem?.thickness ?? {},
									outerMaterial: findedOemRequestItem?.outerMaterial ?? {},
									innerMaterial: findedOemRequestItem?.innerMaterial ?? {},
									printingOption: findedOemRequestItem?.printingOption ?? {},
									forming: findedOemRequestItem?.forming ?? {},
									sustainabilities: findedOemRequestItem?.sustainabilities ?? [],
									certificates: findedOemRequestItem?.certificates ?? [],
									quantities: [{ quantity: item.quantity ?? 0 }],
									requestPrice: [{ price: item.requestPrice ?? 0 }],
									quotePrice: [{ price: item.quotePrice ?? 0 }],
									title: item.title,
									isFixed: item.isFixed,
									remark: item.remark,
									isDelete: false,
									isCreate: false,
								})
							} else {
								const added = acc.find(
									(aItem: any) =>
										aItem.product?.id === item.productId &&
										aItem.oemRequestItemId === item.oemRequestItemId
								)
								if (added) {
									const index = acc.findIndex(
										(aItem: any) =>
											aItem.product?.id === item.productId &&
											aItem.oemRequestItemId === item.oemRequestItemId
									)
									acc[index].quantities.push({ quantity: item.quantity ?? 0 })
									acc[index].requestPrice.push({ price: item.requestPrice ?? 0 })
									acc[index].quotePrice.push({ price: item.quotePrice ?? 0 })
								} else {
									acc.push({
										id: item.id,
										oemRequestItemId: item.oemRequestItemId,
										documentStatus: data.documentStatus,
										product: findedOemRequestItem?.product ?? {},
										dimension: findedOemRequestItem?.dimension ?? {},
										options: findedOemRequestItem?.options ?? [],
										accessories: findedOemRequestItem?.accessories ?? [],
										thickness: findedOemRequestItem?.thickness ?? {},
										outerMaterial: findedOemRequestItem?.outerMaterial ?? {},
										innerMaterial: findedOemRequestItem?.innerMaterial ?? {},
										printingOption: findedOemRequestItem?.printingOption ?? {},
										forming: findedOemRequestItem?.forming ?? {},
										sustainabilities: findedOemRequestItem?.sustainabilities ?? [],
										certificates: findedOemRequestItem?.certificates ?? [],
										quantities: [{ quantity: item.quantity ?? 0 }],
										requestPrice: [{ price: item.requestPrice ?? 0 }],
										quotePrice: [{ price: item.quotePrice ?? 0 }],
										title: item.title,
										isFixed: item.isFixed,
										remark: item.remark,
										isDelete: false,
										isCreate: false,
									})
								}
							}
						}

						return acc
					}, [])
					setItems(items)

					// Set Financial
					setFinancial({
						discount: data?.discount ?? '',
						isVatCalculated: data?.isVatCalculated ?? false,
					})

					setIsLoading(false)
					updateLoading(false)
					updateError(false)
				}
			})
		}
	}

	const onBack = () => {
		navigate('/oem/orders')
	}

	const onAddNewItem = () => {
		const newItems = [
			...items,
			{
				documentStatus: data?.documentStatus,
				product: null,
				quantity: 0,
				requestPrice: 0,
				// editable //
				title: '',
				quotePrice: '',
				// editable //
				isFixed: false,
				isDelete: false,
				isCreate: true,
			},
		]

		setItems(newItems)

		if (!hasChanged) {
			setHasChanged(true)
		}
	}

	const onDeleteItem = (index: number) => {
		const newItems = [...items]

		if (newItems[index].isCreate) {
			newItems.splice(index, 1)
			setItems(newItems)
			return
		} else {
			newItems[index].isDelete = true
			setItems(newItems)
		}

		if (!hasChanged) {
			setHasChanged(true)
		}
	}

	const onChangeItemTitle = (value: string, index: number) => {
		const newItems = [...items]
		newItems[index].title = value
		setItems(newItems)

		if (!hasChanged) {
			setHasChanged(true)
		}
	}

	const onChangeItemRemark = (value: string, index: number) => {
		const newItems = [...items]
		newItems[index].remark = value
		setItems(newItems)

		if (!hasChanged) {
			setHasChanged(true)
		}
	}

	const onChangeQuantity = (value: string, index: number) => {
		const isNumber = /^[0-9]*$/.test(value)
		if (!isNumber) {
			return
		}

		const newItems = [...items]
		newItems[index].quantity = value
		setItems(newItems)

		if (!hasChanged) {
			setHasChanged(true)
		}
	}

	const onChangeQuotePrice = (value: string, index: number) => {
		const isNumber = /^[0-9]*\.?[0-9]*$/.test(value)
		if (!isNumber) {
			return
		}

		const newItems = [...items]
		newItems[index].quotePrice = value
		setItems(newItems)

		if (!hasChanged) {
			setHasChanged(true)
		}
	}

	const onChangeDiscount = (value: string) => {
		const isNumber = /^[0-9]*\.?[0-9]*$/.test(value)
		if (!isNumber) {
			return
		}

		setFinancial({
			...financial,
			discount: value,
		})

		if (!hasChanged) {
			setHasChanged(true)
		}
	}

	const onChangeVatCalculated = (value: boolean) => {
		setFinancial({
			...financial,
			isVatCalculated: value,
		})

		if (!hasChanged) {
			setHasChanged(true)
		}
	}

	const updateItems = () => {
		if (!hasChanged || data?.documentStatus !== '10') {
			return
		}

		setIsSubmitting(true)

		const bodyItems = items.map(item => {
			if (item.isFixed) {
				return {
					id: parseInt(item.id),
					quantity: item.quantity,
					quotePrice: item.quotePrice,
					remark: item.remark,
				}
			} else {
				if (item?.isCreate) {
					return {
						title: item.title,
						quantity: item.quantity,
						quotePrice: item.quotePrice,
					}
				} else {
					if (item?.isDelete) {
						return {
							id: parseInt(item.id),
							title: item.title,
							quotePrice: item.quotePrice,
							delete: true,
						}
					} else {
						return {
							id: parseInt(item.id),
							title: item.title,
							quantity: item.quantity,
							quotePrice: item.quotePrice,
						}
					}
				}
			}
		})

		const body = {
			items: bodyItems,
			discount: financial.discount,
			isVatCalculated: financial.isVatCalculated,
		}

		update(id ?? '', body).then(({ success, data }) => {
			if (success) {
				Swal.fire({
					title: 'ทำรายการสำเร็จ',
					text: 'ทำรายการสำเร็จ',
					icon: 'success',
					confirmButtonText: 'ปิด',
					showCancelButton: false,
					customClass: {
						confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
						cancelButton: 'btn btn-sm white-button text-kumopack-grey-700 fw-bold',
					},
				}).then(() => {
					fetchData()
					setIsSubmitting(false)
				})
			} else {
				Swal.fire({
					title: 'เกิดข้อผิดพลาด',
					text: data,
					icon: 'error',
					confirmButtonText: 'ปิด',
					customClass: {
						confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
					},
				})
				setIsSubmitting(false)
			}
		})
	}

	const sendItems = async () => {
		if (data?.documentStatus !== '10') {
			return
		}

		setIsSubmitting(true)

		if (hasChanged) {
			const bodyItems = items.map(item => {
				if (item.isFixed) {
					return {
						id: parseInt(item.id),
						quantity: item.quantity,
						quotePrice: item.quotePrice,
						remark: item.remark,
					}
				} else {
					if (item?.isCreate) {
						return {
							title: item.title,
							quotePrice: item.quotePrice,
							quantity: item.quantity,
						}
					} else {
						if (item?.isDelete) {
							return {
								id: parseInt(item.id),
								title: item.title,
								quotePrice: item.quotePrice,
								quantity: item.quantity,
								delete: true,
							}
						} else {
							return {
								id: parseInt(item.id),
								title: item.title,
								quotePrice: item.quotePrice,
								quantity: item.quantity,
							}
						}
					}
				}
			})

			const body = {
				items: bodyItems,
				discount: financial.discount,
				isVatCalculated: financial.isVatCalculated,
			}

			const { success, data } = await update(id ?? '', body)
			if (!success) {
				Swal.fire({
					title: 'เกิดข้อผิดพลาด',
					text: data,
					icon: 'error',
					confirmButtonText: 'ปิด',
					customClass: {
						confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
					},
				})
				setIsSubmitting(false)
			}
		}

		send(id ?? '').then(({ success, data }) => {
			if (success) {
				Swal.fire({
					title: 'ทำรายการสำเร็จ',
					text: 'ทำรายการสำเร็จ',
					icon: 'success',
					confirmButtonText: 'ปิด',
					showCancelButton: false,
					customClass: {
						confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
						cancelButton: 'btn btn-sm white-button text-kumopack-grey-700 fw-bold',
					},
				})
				fetchData()
				setIsSubmitting(false)

				navigate('/oem/orders', {
					state: {
						status: OEMFilter['send']['value'],
					},
				})
			} else {
				Swal.fire({
					title: 'เกิดข้อผิดพลาด',
					text: data,
					icon: 'error',
					confirmButtonText: 'ปิด',
					customClass: {
						confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
					},
				})
				setIsSubmitting(false)
			}
		})
	}

	const onUpdateItem = () => {
		itemsValidationSchema
			.validate(items, { abortEarly: false })
			.then(() => {
				Swal.fire({
					icon: 'question',
					text: 'ยืนยันการบันทึกข้อมูล',
					confirmButtonText: 'ยืนยัน',
					cancelButtonText: 'ยกเลิก',
					showCancelButton: true,
					customClass: {
						confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
						cancelButton: 'btn btn-sm white-button text-kumopack-grey-700 fw-bold',
					},
				}).then(result => {
					if (result.isConfirmed) {
						updateItems()
					}
				})
			})
			.catch(err => {
				Swal.fire({
					title: 'กรุณากรอกราคาที่ต้องการเสนอให้ครบทุกรายการ',
					icon: 'error',
					confirmButtonText: 'ปิด',
					customClass: {
						confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
					},
				})
			})
	}

	const onSendItem = () => {
		Swal.fire({
			icon: 'question',
			text: 'ยืนยันการส่งใบเสนอราคา',
			confirmButtonText: 'ยืนยัน',
			cancelButtonText: 'ยกเลิก',
			showCancelButton: true,
			customClass: {
				confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
				cancelButton: 'btn btn-sm white-button text-kumopack-grey-700 fw-bold',
			},
		}).then(result => {
			if (result.isConfirmed) {
				toast.info('กำลังทำรายการส่งใบเสนอราคา')
				sendItems()
			}
		})
	}

	const TABLE_COLUMNS: any[] = [
		{
			Header: 'ชื่อ',
			accessor: 'product',
			width: 600,
			minWidth: 600,
			canInput: disabledInput,
			Cell: TitleCell,
			onChangeItemTitle,
			onChangeItemRemark,
		},
		{
			Header: () => <div className="text-end">จำนวนที่สั่งผลิต</div>,
			headerRight: true,
			accessor: 'quantity',
			width: 200,
			minWidth: 200,
			Cell: QuantityInputCell,
			canInput: disabledInput,
			onChange: onChangeQuantity,
			// Cell: ({ value, row }: any) => {
			// 	if (row.original.isFixed) {
			// 		return <QuantityCell quantity={value} unit="" />
			// 	} else {
			// 		return (
			// 			<div className="d-flex justify-content-end">
			// 				<div>-</div>
			// 			</div>
			// 		)
			// 	}
			// },
		},
		{
			Header: () => <div className="text-end">ราคาที่ผู้ซื้อเสนอต่อหน่วย</div>,
			headerRight: true,
			accessor: 'requestPrice',
			width: 200,
			minWidth: 200,
			Cell: ({ value, row }: any) => {
				if (row.original.isFixed) {
					if (row.original.documentStatus === '10')
						return <TotalPriceCell price={value ?? '0.00'} />
					else {
						return <MultiplePriceCell prices={value} />
					}
				} else {
					return (
						<div className="d-flex justify-content-end">
							<div>-</div>
						</div>
					)
				}
			},
		},
		{
			Header: () => <div className="text-end">ราคาที่ผู้ผลิตเสนอต่อหน่วย</div>,
			headerRight: true,
			accessor: 'quotePrice',
			width: 200,
			minWidth: 200,
			Cell: QuotePriceCell,
			canInput: disabledInput,
			onChange: onChangeQuotePrice,
		},
		{
			Header: () => <div className="text-end">ยอดรวม</div>,
			headerRight: true,
			accessor: 'totalPrice',
			width: 150,
			minWidth: 150,
			Cell: ({ row }: any) => {
				if (row.original.documentStatus === '10') {
					let price = 0 as any

					const { quotePrice, quantity } = row.original
					const parsedQuotePrice = parseFloat(quotePrice)
					const parsedQuantity = parseInt(quantity)

					if (!isNaN(parsedQuotePrice) && !isNaN(parsedQuantity)) {
						price = (parsedQuotePrice * parseFloat(quantity)).toFixed(2)
					}

					return <TotalPriceCell price={price as any} />
				} else {
					const prices = row.original.quotePrice.map((item: any, index: number) => ({
						price: item.price * row.original.quantities[index].quantity,
					}))

					return <MultiplePriceCell prices={prices} />
				}
			},
		},
		{
			Header: '',
			accessor: 'isFixed',
			width: 50,
			minWidth: 50,
			Cell: ({ value, row }: any) => {
				if (!value && row.original.documentStatus === '10') {
					return (
						<button
							className="btn btn-icon btn-custom btn-active-light rounded-circle"
							onClick={() => onDeleteItem(row.index)}>
							<img
								src="/media/icons/kumopack/delete.svg"
								alt="Dot Vertical Icon"
								width={20}
								height={20}
							/>
						</button>
					)
				} else {
					return <></>
				}
			},
			disableSortBy: true,
		},
	]

	useEffect(() => {
		fetchData()
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (isNegotitated) {
			Swal.fire({
				icon: 'info',
				title: 'ผู้ซื้อต้องการเจรจา',
				text: negotitateRemark,
				confirmButtonText: 'ปิด',
				showCancelButton: false,
				customClass: {
					confirmButton: 'btn btn-sm btn-kumopack-primary-600 text-kumopack-base-white',
					cancelButton: 'btn btn-sm white-button text-kumopack-grey-700 fw-bold',
				},
			})
		}
	}, [isNegotitated, negotitateRemark])

	useEffect(() => {
		setShowContentToolbar(false)
		setCustomContentToolbar(null)
		updateSorting('product', false)

		return () => {
			setShowContentToolbar(true)
			setCustomContentToolbar(null)
			clearState()
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return {
		disabledInput,
		isNegotitated,
		negotitateRemark,
		canSend,
		isSubmitting,
		isLoading,
		data,
		items: displayItems,
		financial,
		vatAmount,
		netBeforeVat,
		net,
		TABLE_COLUMNS,
		onBack,
		onUpdateItem,
		onSendItem,
		onAddNewItem,
		onChangeDiscount,
		onChangeVatCalculated,
	}
}

export default ViewModel
